<template>
  <div class="dd-mobile-menu">
    <!-- Without ellipsis off, Element Plus folds items it thinks don't fit into a "..." submenu -->
    <el-menu :class="{'go-native-ios' : $screen.isGoNativeiOSMobileApp($mq)}" :ellipsis="false" mode="horizontal">
      <el-menu-item v-for="(item, idx) in navItems" :key="idx" :index="`${idx}`">
        <router-link
          :to="item.to || { name: item.pathName }"
          :title="item.label"
          :class="{'active': item.pathName.toLowerCase() ===  $route.name}"
        >
          <i :class="'ddi ddi-' + item.icon" />
          <span>{{ item.label }}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item v-if="$permissions.isNotGuest && !$permissions.isAppSumoAccount && ($route.fullPath.indexOf('/project/') > 0 || $route.fullPath.indexOf('/project-schedule/') > 0)  && $route.params.id" index="schedule">
        <router-link
          :to="{ name: routerNames.PROJECT_SCHEDULE, params: { id: $route.params.id } }"
          :title="'Scheduled Tasks'"
          :class="{'active': routerNames.PROJECT_SCHEDULE.toLowerCase() ===  $route.name}"
        >
          <i class="ddi ddi-clock" />
          <span>Scheduled Tasks</span>
        </router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import * as routerNames from '@/services/router/router.names'
import RouteAssistant from '@/helpers/route-assistant'

export default defineComponent({
  name: 'DdMobileMenu',

  data() {
    return {
      routerNames,
    }
  },

  computed: {
    // The project or mailbox the current page is in; workflow pages have an :id too, so the path decides
    entityId(): string | undefined {
      const id = this.$route.params.id as string | undefined
      return id && /\/(project|project-schedule|mailbox)\//.test(this.$route.path)
        ? id
        : undefined
    },

    // Opens filtered to the current project or mailbox, like the Calendar link in their desktop headers, which
    // mobile hides
    calendarRoute(): any {
      return RouteAssistant.getCalendarRoute(this.$route.params.accountId as string, this.entityId)
    },

    navItems(): Array<any> {
      return this.$permissions.isNotGuest
        ? [
            {
              label: 'Home',
              icon: 'home',
              pathName: routerNames.DASHBOARD,
            },
            {
              label: 'Tasks',
              icon: 'task',
              pathName: routerNames.ALL_TASKS,
            },
            {
              label: 'Conversations',
              icon: 'conversation',
              pathName: routerNames.ALL_CONVERSATIONS,
            },
            {
              label: 'Calendar',
              icon: 'calendar',
              pathName: routerNames.CALENDAR,
              to: this.calendarRoute,
            },
          ]
        : [
            {
              label: 'Home',
              icon: 'home',
              pathName: routerNames.DASHBOARD,
            },
            {
              label: 'Tasks',
              icon: 'task',
              pathName: routerNames.ALL_TASKS,
            },
            {
              label: 'Calendar',
              icon: 'calendar',
              pathName: routerNames.CALENDAR,
              to: this.calendarRoute,
            },
          ]
    },
  },
})
</script>

<style lang="scss">
.dd-mobile-menu {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $zindex-fixed;
  min-width: 320px;

  .el-menu {
    display: flex;
    background-color: var(--color-background-header);
    border: none;

    &.go-native-ios {
      padding-bottom: 20px;
    }

    &--horizontal {
      border-top: var(--border-bottom-thick);
    }

    &-item {
      width: 100%;
      height: 49px;
      padding: 4px 7px;
      color: $color--gray-60 !important;
      border: none;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        background-color: var(--color-background-hover) !important;
      }

      > a {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 41px;

        &.active {
          > * {
            color: $reddish-orange;
          }
        }

        &:hover {
          text-decoration: none;
        }

        i {
          font-size: 18px;
          line-height: 24px;
          color: var(--color-text-primary);
        }

        > span {
          @include lettering--p-xs;
          color: var(--color-text-primary);
        }
      }
    }
  }
}
</style>
